import { Helpers } from '../../helpers';
import { IPriorityRankingCategory } from '../../interfaces/ipriority-ranking-category';
import { Well } from '../well';

export class PriorityRankingCategoryBase {
  PriorityRankingCategoryId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Wells_PriorityRankingCategory?: Array<Well> | null;

  constructor(item?: IPriorityRankingCategory) {
    if (item) {

      this.PriorityRankingCategoryId = item.PriorityRankingCategoryId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Wells_PriorityRankingCategory = Helpers.createClassArray(Well, item.Wells_PriorityRankingCategory);
    }
  }
}